import * as yup from 'yup';

import { YearEndProcedureSettingsRes } from '../types';

export const createSchema = (
  yearClosureSettings: YearEndProcedureSettingsRes | undefined
) => {
  const schemaShapes = {};

  yearClosureSettings?.settings.forEach((field) => {
    const isSettingEnabled = field.value === 'true';

    schemaShapes[field.settingId] = isSettingEnabled
      ? yup.boolean().default(true)
      : yup.boolean().default(false);
  });

  return yup.object().shape(schemaShapes);
};
